<template>
  <rest-form-item :label="tooltip ? '' : label" :prop="prop">
    <el-select
      v-model="model"
      filterable
      remote
      :placeholder="placeholder || $t('Segment_Placeholder')"
      :remote-method="fetchSegmentsDropdown"
      :clearable="clearable"
      :multiple="multiple"
      v-loading="loadingSegments"
      :disabled="readOnly"
      data-qa="segment-select-input"
      @change="$emit('change')"
    >
      <el-option
        v-if="placeholder"
        :value="null"
        :label="placeholder || $t('Segment_Placeholder')"
      />
      <el-option-group v-if="predefined" :label="$t('Segment_Predefined')">
        <el-option
          v-if="predefined && predefined.length > 0"
          v-for="item in predefined"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        />
      </el-option-group>
      <el-option-group v-if="predefined" :label="$t('Segment_User_Created')">
        <el-option
          v-for="item in segments"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        />
      </el-option-group>
      <el-option
        v-else
        v-for="item in segments"
        :key="item.id"
        :label="item.title"
        :value="item.id"
      />
    </el-select>
    <template v-if="tooltip" #label>
      {{ label }}
      <form-item-i-tooltip :tooltip-content="tooltip" />
    </template>
  </rest-form-item>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'
import RestApi from '@/core/services/RestApi'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'MultipleSegmentSelect',

  components: {
    FormItemITooltip,
    RestFormItem
  },

  data() {
    return {
      loadingSegments: true,
      segments: {}
    }
  },

  props: {
    prop: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    tooltip: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    predefined: {
      type: [Boolean, Array],
      required: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  async mounted() {
    await this.fetchSegments()

    if (this.value) {
      this.fetchMissingPreselectedSegments(this.value)
    }
  },

  computed: {
    model: {
      get() {
        if (this.multiple) {
          return this.value && this.value.length
            ? this.value.map(i => parseInt(i))
            : []
        } else {
          return this.value && Number.isInteger(this.value)
            ? parseInt(this.value)
            : undefined
        }
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    async fetchSegments() {
      this.loadingSegments = true
      const params = {
        'per-page': 50
      }

      const paginator = new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: 'segments',
          params: params
        })
      )

      try {
        const { data } = await paginator.fetchPage(1)
        this.segments = data
      } catch (error) {
        console.error('Error fetching segments:', error)
        this.$message({
          message: error.message,
          type: 'error'
        })
      } finally {
        this.loadingSegments = false
      }
    },

    fetchSegmentsDropdown(query) {
      this.loadingSegments = true

      let params = { sort: 'title', 'per-page': 50 }

      if (query !== null && query !== '') {
        params.title = query
      }

      let endpoint = projectEndpoint({
        method: 'get',
        url: 'segments',
        params: params
      })

      RestApi(endpoint)
        .then(({ data }) => {
          this.segments = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loadingSegments = false
        })
    },

    async fetchMissingPreselectedSegments(value) {
      let unfetchedSegments = []
      let fetchedSegmentIds = this.segments.map(i => i.id)

      if (Array.isArray(value)) {
        value.forEach(item => {
          if (!fetchedSegmentIds.includes(parseInt(item))) {
            unfetchedSegments.push(item)
          }
        })
      } else {
        if (!fetchedSegmentIds.includes(parseInt(value))) {
          unfetchedSegments.push(value)
        }
      }

      if (!unfetchedSegments.length) {
        return
      }

      this.loadingSegments = true
      const params = {
        'per-page': 50,
        id: unfetchedSegments.join(',')
      }

      const paginator = new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: 'segments',
          params: params
        })
      )

      try {
        const { data } = await paginator.fetchPage(1)
        this.segments.push(...data)
      } catch (error) {
        console.error('Error fetching segments:', error)
        this.$message({
          message: error.message,
          type: 'error'
        })
      } finally {
        this.loadingSegments = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/MultipleSegmentSelect.vue